import React from "react";

export default function WhyChooseMatrixBrainsTable() {

    return (
        <section class="py-0">
            <div className="container">
                <div
                    className="row"
                    data-anime='{ "el": "childs", "translateY": [30, 0], "opacity": [0,1], "duration": 800, "delay": 200, "staggervalue": 300, "easing": "easeOutQuad" }'
                >
                    <div className="col-lg-11 offset-lg-1 text-center text-lg-start">
                        <div className="row border-top border-color-dark-gray g-0">
                            <div className="col-6 last-paragraph-no-margin ps-30px pe-30px pt-15px pb-15px align-self-center d-inline-flex">
                                <div className="feature-box-icon me-10px">
                                    <i className="bi bi-check2-circle icon-very-medium text-base-color" />
                                </div>
                                <span className="text-dark-gray fs-14 fw-600">Agile Development Methodology</span>
                            </div>
                            <div className="col-6 last-paragraph-no-margin ps-30px pe-30px pt-15px pb-15px border-start border-color-dark-gray d-inline-flex">
                                <div className="feature-box-icon me-10px">
                                    <i className="bi bi-check2-circle icon-very-medium text-base-color" />
                                </div>
                                <span className="text-dark-gray fs-14 fw-600">Cost-Effective Solutions</span>
                            </div>
                        </div>
                        <div className="row border-top border-color-dark-gray g-0">
                            <div className="col-6 last-paragraph-no-margin ps-30px pe-30px pt-15px pb-15px align-self-center d-inline-flex">
                                <div className="feature-box-icon me-10px">
                                    <i className="bi bi-check2-circle icon-very-medium text-base-color" />
                                </div>
                                <span className="text-dark-gray fs-14 fw-600">On-Time Delivery</span>
                            </div>
                            <div className="col-6 last-paragraph-no-margin ps-30px pe-30px pt-15px pb-15px border-start border-color-dark-gray d-inline-flex">
                                <div className="feature-box-icon me-10px">
                                    <i className="bi bi-check2-circle icon-very-medium text-base-color" />
                                </div>
                                <span className="text-dark-gray fs-14 fw-600">Dedicated Project Manager</span>
                            </div>
                        </div>
                        <div className="row border-top border-color-dark-gray g-0">
                            <div className="col-6 last-paragraph-no-margin ps-30px pe-30px pt-15px pb-15px align-self-center d-inline-flex">
                                <div className="feature-box-icon me-10px">
                                    <i className="bi bi-check2-circle icon-very-medium text-base-color" />
                                </div>
                                <span className="text-dark-gray fs-14 fw-600">Transparent Communication</span>
                            </div>
                            <div className="col-6 last-paragraph-no-margin ps-30px pe-30px pt-15px pb-15px border-start border-color-dark-gray d-inline-flex">
                                <div className="feature-box-icon me-10px">
                                    <i className="bi bi-check2-circle icon-very-medium text-base-color" />
                                </div>
                                <span className="text-dark-gray fs-14 fw-600">Performance Optimization</span>
                            </div>
                        </div>
                        <div className="row border-top border-bottom border-color-dark-gray g-0">
                            <div className="col-6 last-paragraph-no-margin ps-30px pe-30px pt-15px pb-15px align-self-center d-inline-flex">
                                <div className="feature-box-icon me-10px">
                                    <i className="bi bi-check2-circle icon-very-medium text-base-color" />
                                </div>
                                <span className="text-dark-gray fs-14 fw-600">Customized Solutions</span>
                            </div>
                            <div className="col-6 last-paragraph-no-margin ps-30px pe-30px pt-15px pb-15px border-start border-color-dark-gray d-inline-flex">
                                <div className="feature-box-icon me-10px">
                                    <i className="bi bi-check2-circle icon-very-medium text-base-color" />
                                </div>
                                <span className="text-dark-gray fs-14 fw-600">Innovative Solutions</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}